import React from 'react';
import Icon from '@/components/AppIcon';
import { useAssistant } from '@/contexts/AssistantContext';

// Clears the thread and starts a fresh server session on the next message.
// Shown once there is a conversation to clear (popup header and /assistant).
const NewChatButton = () => {
  const { resetConversation, thread, sending } = useAssistant();
  if (thread.length === 0) return null;
  return (
    <button
      type="button"
      onClick={resetConversation}
      disabled={sending}
      className="flex items-center gap-1.5 rounded-md px-2 py-1 text-xs font-medium text-muted-foreground hover:text-foreground hover:bg-muted transition-athletic disabled:opacity-50"
      aria-label="Start a new conversation"
      title="Start a new conversation"
    >
      <Icon name="Plus" size={14} />
      <span>New chat</span>
    </button>
  );
};

export default NewChatButton;
